const STORAGE_PREFIX = 'feature-tour';
const HINT_STORAGE_PREFIX = 'feature-hint';

export function tourStorageKey(userId, tourId, version) {
  return `${STORAGE_PREFIX}:${userId}:${tourId}:v${version}`;
}

export function hintStorageKey(userId, hintSetId, version) {
  return `${HINT_STORAGE_PREFIX}:${userId}:${hintSetId}:v${version}`;
}

export function isTourDismissed(userId, tourId, version) {
  if (userId == null || !tourId) return true;
  try {
    return localStorage.getItem(tourStorageKey(userId, tourId, version)) === '1';
  } catch (error) {
    return true;
  }
}

export function markTourDismissed(userId, tourId, version) {
  if (userId == null || !tourId) return;
  try {
    localStorage.setItem(tourStorageKey(userId, tourId, version), '1');
  } catch (error) {
    // Ignore quota / private mode failures — tour may reappear.
  }
}

export function clearTourDismissed(userId, tourId, version) {
  if (userId == null || !tourId) return;
  try {
    localStorage.removeItem(tourStorageKey(userId, tourId, version));
  } catch (error) {
    // Ignore private mode failures.
  }
}

export function isHintSetDismissed(userId, hintSetId, version) {
  if (userId == null || !hintSetId) return true;
  try {
    return localStorage.getItem(hintStorageKey(userId, hintSetId, version)) === '1';
  } catch (error) {
    return true;
  }
}

export function markHintSetDismissed(userId, hintSetId, version) {
  if (userId == null || !hintSetId) return;
  try {
    localStorage.setItem(hintStorageKey(userId, hintSetId, version), '1');
  } catch (error) {
    // Ignore quota / private mode failures.
  }
}

export function clearHintSetDismissed(userId, hintSetId, version) {
  if (userId == null || !hintSetId) return;
  try {
    localStorage.removeItem(hintStorageKey(userId, hintSetId, version));
  } catch (error) {
    // Ignore private mode failures.
  }
}
